export default "__VITE_ASSET__Bk_v6gvC__"